<template>
  <div class="page">
    <div class="tab">
      <router-link
        class="tab-item"
        active-class="active"
        v-for="item in menuItems"
        :key="item.path"
        :to="{
          path: item.path,
          query: { name: name }
        }"
      >
        {{ item.title }}</router-link
      >
    </div>

    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>


<script>
export default {
  components: {}, 
  data() {
    return {
      name: "",
      index: 1,
      menuItems: [
        { id: 1, title: "企业工商信息", path: "/ent/Information" },
        { id: 2, title: "经营风险", path: "/ent/OperatingRisk" },
        { id: 3, title: "法律诉讼", path: "/ent/Litigation"}
      ],
    };
  },
  created() {
    let me = this;
    me.name = me.$route.query.name;
  },
  methods: {
    open(path) {
      let me = this;
      me.$router.push(path);
    },
  },
};
</script>


<style scoped>
.page {
  width: 100%;
  background: #fff;
}
.tab {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.tab-item {
  flex: 1;
  text-align: center;
  padding: 10px 0px;
  color: #333;
  border: 1px solid #eee;
}
.active{
    color: #3693f8 !important;
}
</style>